import { SecondaryButton, Space } from '@procurify/ui'

import { Price } from '@webapp/core/components/Price'
import { type CurrencyName } from '@webapp/core/entities/external/Currency'
import { useProcurifyIntl } from '@webapp/hooks'
import { SpendingCardRegion } from '@webapp/modules/spending-cards/entities/enums/SpendingCardRegionEnum'
import { useSpendingCardRegion } from '@webapp/modules/spending-cards/hooks/useSpendingCardRegion'
import messages from './messages'
import { PhysicalCardPinPresenterStyled } from './styles/PhysicalCardPinPresenterStyled'
import { usePhysicalCardPinPresenter } from './usePhysicalCardPinPresenter'

const visaBusinessSVG = require('!svg-url-loader!./assets/visa-logo-business.svg')
const visaCommercialSVG = require('!svg-url-loader!./assets/visa-logo-commercial.svg')

export interface ICardPinButtonPresenterProps {
  externalId: string
  scaToken?: string
  onVerificationRequired?: (scaSessionCode: string) => void
  last4Digits: string
  balance: string
  currency: CurrencyName
  ariaLabel?: string
}

export const PhysicalCardPinPresenter = ({
  externalId,
  scaToken,
  onVerificationRequired,
  last4Digits,
  balance,
  currency,
  ariaLabel,
}: ICardPinButtonPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    commands: { openCardPinModal },
    states: { showLoader },
  } = usePhysicalCardPinPresenter({
    externalId,
    scaToken,
    onVerificationRequired,
  })

  const { region } = useSpendingCardRegion()

  return (
    <PhysicalCardPinPresenterStyled
      aria-label={
        ariaLabel ||
        intl.formatMessage(messages.cardAriaLabel, {
          cardNumber: last4Digits,
        })
      }
    >
      <Space direction='horizontal' justify='space-between'>
        <Price
          price={balance}
          currency={currency}
          aria-label={intl.formatMessage(messages.availableBalanceLabel)}
        />

        <SecondaryButton
          onClick={() => openCardPinModal()}
          icon='visible'
          isLoading={showLoader}
          disabled={showLoader}
        >
          {intl.formatMessage(messages.showPinButtonText)}
        </SecondaryButton>
      </Space>

      <Space direction='horizontal' justify='space-between' align='center'>
        <span>•••• {last4Digits}</span>

        <img
          alt={intl.formatMessage(messages.visaLogoAltText)}
          className='network-logo'
          src={
            region === SpendingCardRegion.UK
              ? visaBusinessSVG
              : visaCommercialSVG
          }
          width='100%'
        />
      </Space>
    </PhysicalCardPinPresenterStyled>
  )
}
